import { CommonModule } from '@angular/common';
import { Component, HostListener, LOCALE_ID, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonNgModule } from '../../shared/modules/common-ng/common-ng.module';
import { PrimeModuleModule } from '../../shared/modules/prime-module/prime-module.module';
import { UiKitModule } from '../../shared/modules/ui-kit/ui-kit.module';
import { TabViewComponent } from '../../ui-kit/atoms/tab-view/tab-view.component';
import { TabMenuRestitucionComponent } from '../../ui-kit/organisms/tab-menu-restitucion/tab-menu-restitucion.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { RecaptchaVerifyService } from '../../services/recaptcha-verify.service';
import { ConsultaService } from '../../services/consulta.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { MessageService } from 'primeng/api';
import { ResponseInterceptor } from '../../response.interceptor';
import { NotificationService } from '../../services/notification.service';
import { RestitucionService } from '../../services/restitucion.service';
import { UtilsService } from '../../services/utils.service';
import { NotificacionFirmaMandatoComponent } from '../notificacion-firma-mandato/notificacion-firma-mandato.component';
import { CheckboxModule } from 'primeng/checkbox';
import { EncryptionService } from '../../services/encryption.service';
import { ModalCompensacionComponent } from '../../ui-kit/organisms/modal-compensacion/modal-compensacion.component';
import { ModalMessageService } from '../../services/modal-message.service';

@Component({
  selector: 'app-compensacion-deudas-excedentes',
  standalone: true,
  providers:[
    UtilsService,
    NotificationService,
    RecaptchaVerifyService,
    MessageService,
    ConsultaService,
    RestitucionService,
    EncryptionService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseInterceptor,
      multi: true
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKeyV3,
    },
    { provide: LOCALE_ID, useValue: 'es' }
  ],
  imports: [
    CommonModule,
    CommonNgModule,
    UiKitModule,
    PrimeModuleModule,
    TabMenuRestitucionComponent,
    TabViewComponent,
    ModalCompensacionComponent,
    NotificacionFirmaMandatoComponent,
    CheckboxModule
  ],
  templateUrl: './compensacion-deudas-excedentes.component.html',
  styleUrl: './compensacion-deudas-excedentes.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CompensacionDeudasExcedentesComponent {
  typeApp:any = undefined;
  dataTabMenu:any = [];
  tabView_index: any = 10;
  viewTabMenuRestitucion:boolean = false;
  submitted: boolean          = false;
  verifyRutCampo: boolean     = false;
  verifyDctoCampo: boolean     = false;
  parrafoModal: any;
  viewModal:boolean = false;
  viewBanner:boolean = false;
  themeTabMenu:any = 'tab-menu-restitucion';
  activeBreadCrumbs:boolean = false;
  nuevaConsulta:boolean = false;
  formData!: FormGroup;
  formDataFirma!: FormGroup;
  loading: boolean = false;
  disabledBtn:boolean = false;
  tituloModal:any;
  modalCustomIcon:any;
  accionCerrarModal: any;
  filterRut:any =  'num';
  filterDocument = 'alphanum';
  recaptchaV2Response!: any;
  textBienvenido:any = 'Porque nuestro compromiso es entregarte más y mejores beneficios, a partir de esta fecha, ponemos a tu disposición la opción de utilizar tus excedentes generados por restituciones derivadas de la implementación de la Ley N° 21.674 (“Ley Corta de Isapres”), para pagar tanto las deudas que a la fecha mantengas con Colmena como las que a futuro pudieren generarse, optando al beneficio de condonación de intereses y recargos.';
  activeHead:boolean = false;
  viewModalNotifcation: boolean = false;
  codeResponseNotification:any;
  currentRutUser:any;
  folioMandato: any;
  viewNotificationFirma:boolean = false;
  revisorPreMandato:boolean = false;
  styleBtnPreMandato:any = 'btn-submit';
  labelBtnPreMandato:any = 'Revisar pre mandato';
  nombreAfiliado: any;
  themeBannerCompensacion:any = 'bannerCompensacion no-validar-datos';

  idApp: any;
  opcion: any;
  rut: any;
  data:any;
  
  verifyRecaptcha = (response: any) => {
    if (response.length > 0) {
      this.submitted = true;
      this.recaptchaV2Response = response;
      this.getResponseForm();
      setTimeout(() => {
        grecaptcha.reset();
      }, 120);
    }
  };
  

  private minLengthRut = 8;
  @HostListener('input', ['$event'])
  onInput(event: Event) {
      const input = event.target as HTMLInputElement;
      let value = input.value.trim();
      if (value.length >= this.minLengthRut) {
      this.filterRut = 'alphanum';
      } else if (value.length < this.minLengthRut) {
      this.filterRut = 'num';
      }
  }


  onRutInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();

    this.filterRut = value.length >= this.minLengthRut ? 'alphanum' : 'num';
  }

  
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private readonly recaptchaVerifyService: RecaptchaVerifyService,
    private readonly consultaService: ConsultaService,
    private readonly utilsService: UtilsService,
    private readonly restitucionService :RestitucionService,
    private encryptionService: EncryptionService,
    public modalMessageService: ModalMessageService
  ){

    this.formData = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(10)]],
      nDocumento: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(10)]],
    });

    this.formDataFirma = this.fb.group({
      checkFirma: [false, [Validators.required]]
    });

    const base64EncodedQueryString:any = this.activatedRoute.snapshot.paramMap.get('qs');
    let encodedQueryString = '';
    encodedQueryString = atob(base64EncodedQueryString);
    
    try {
      const decodedQueryString:any = encodedQueryString;//encryptionService.decryptData(encodedQueryString);
      const params = new URLSearchParams(decodedQueryString);
      this.idApp = params.get('idApp'); // "3"
      this.opcion = params.get('opcion'); // "mov"
      this.rut = params.get('rut'); // "123"
      this.data = params.get('data');

      if(this.data!= null) {
        let textoSinSaltos = this.data.replace(/\\r/g, "");
        sessionStorage.setItem('segurito', btoa(textoSinSaltos));
      }

    } catch (error) {
      this.modalMessageService.openModal(
        '¡Ups!',
        'No se pudo cargar la consulta, por favor intenta más tarde',
        false,
        false
      );
      this.nuevaConsulta = true;
    }

    if( this.idApp ) {
      this.configuracionContextApp(this.idApp, this.opcion, this.rut);
    }else {
      window.location.href='https://www.colmena.cl';
    }
    

  //  this.openModal('revisar-datos', null)

  }

  get f() { return this.formData.controls; }

  refreshPage(){
    window.location.reload();
  }

  configuracionContextApp(idApp:any, opcion:any, rut:any){
    this.typeApp = idApp;
    switch (idApp) {
      case '0':
        this.activeBreadCrumbs = true;
        this.activeHead = false;
        // this.activeHead = false;
        // this.textBienvenido = 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
        // alert('Sitio Privado');
      break;
      case '1':
        this.activeBreadCrumbs = true;
        this.activeHead = true;
        // this.textBienvenido= 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
        // // alert('Sitio Publico');
        // if(this.tabView_index != 0) {
        //   this.viewBanneer = true;
        // }
      break;
      case '2':
        this.activeBreadCrumbs = true;
        this.activeHead = false;
        // this.textBienvenido = 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
        // // alert('App');
      break;
      case '3':
        this.activeBreadCrumbs = true;
        this.activeHead = true;
        // this.textBienvenido= 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
        // if (opcion === 'plan') {
        //   this.themeTabMenu = 'tab-menu-restitucion oneTab';
        //   // alert('PLAN DE PAGO');
        //   this.dataTabMenu[0].viewMenu = false;
        //   this.dataTabMenu[1].viewMenu = true;
        //   this.dataTabMenu[2].viewMenu = false;
        //   this.dataTabMenu[3].viewMenu = false;
        //   this.dataTabMenu[4].viewMenu = false;
        //   // this.tabView_index = 1;
         
        // }else if (opcion === 'mov') {
        //   // alert('MOVIMIENTOS');
        //   this.themeTabMenu = 'tab-menu-restitucion oneTab';
        //   this.formData?.controls['username']?.setValue(rut);
        //   this.resumenMovimientosRestitucion();
        //   this.resumenCuentaRestitucion();
        //   this.currentRutUser =  this.formData.controls['username'].value;
        //   this.dataTabMenu[0].viewMenu  = false;
        //   this.dataTabMenu[1].viewMenu  = false;
        //   this.dataTabMenu[2].viewMenu  = false;
        //   this.dataTabMenu[3].active    = true;
        //   this.dataTabMenu[3].viewMenu = true;
        //   this.dataTabMenu[4].viewMenu = false;
        //   this.viewTabMenuRestitucion = true;
        //   this.tabView_index = 3;
        // }
        // // alert('Otra');
        // this.viewBanneer = false;
      break;
    }
  }

  getTabViewSelected($event:any) {
    // console.log('$event', $event);
    this.tabView_index = $event.item['id'];
    if(this.tabView_index != 0) {
      this.viewBanner = true;
    }else if (this.tabView_index === 0) {
      this.viewBanner = false;
    }
  }

  onSubmit(){
    this.submitted = true;
    if (this.formData.valid) {
      this.loading = true;
      this.disabledBtn = true;
      this.crearSolicitud();
    }
  }

  crearSolicitud() {
    grecaptcha.ready(() => {
      grecaptcha.execute(environment.recaptcha.siteKeyV3, { action: 'contacto' }).then((token) => {
        this.recaptchaVerifyService.verifyRecaptchaCode(token).subscribe(resp => {
          // console.log('verifyRecaptchaCode', resp);
          // resp.score = 0.1; // Forzar para ejecutar Recaptcha 2
          if (resp.success && resp.score >= 0.5) {
            this.validacionIdentidad();
          } else {
            this.executeRecaptchav2();
          }
        });
      });
    });
  }

  validacionIdentidad(){
    const payload:any = {
      "documentNumber": this.formData.controls['username'].value,
      "documentSerialNumber": this.formData.controls['nDocumento'].value
    }
    this.consultaService.validacionIdentidad(payload)
    .subscribe({
      next: (response) => {
        if(response.codigoRetorno == 0) {
          this.validacionCompensacion();
        } else {
          this.modalMessageService.openModal(
            '¡Lo sentimos!',
            response.glosaRetorno,
            false,
            false
          );
          this.nuevaConsulta = true;
        }      
      },
      error: (error) => {
        this.modalMessageService.openModal(
          '¡Ups!',
          error,
          false,
          false
        );
        this.nuevaConsulta = true;
      }
  })
  }

  validacionCompensacion(){
    this.currentRutUser =  this.formData.controls['username'].value;
    this.consultaService.consultaCompensacion().subscribe( (response:any) => {

      // codigos de retorno
      // response.codigoRetorno = 2;
      switch (response.codigoRetorno) {
        case 0: // 0 = rut existe y es vigente
          window.open('https://www.colmena.cl/afiliados/#/login', '_blank');
        break;
        case 1: // 1 = rut existe y no es vigente
        this.openModal('firmar-mandato', null);
        break;
        case 2: // 2 = no tiene compensacion
        this.openModal('no-candidato', null);
        break;
        case 4: // 4 = no pasa validacion identidad
        this.openModal('no-validar-datos', null);
        // setTimeout(() => {
        //   this.refreshPage();
        // }, 6000);
        break; 
      }
      this.loading = false;

      // this.openModal('firmar-mandato', null)
    });

    
  }

  openModal(context:any, error:any){
    switch (context) {
      case 'no-candidato':
        this.themeBannerCompensacion = 'bannerCompensacion no-candidato';
        this.tituloModal = '¡Lo sentimos!';
        this.parrafoModal = 'No reúnes las condiciones necesarias para acceder aplicar al proceso de compensación de deuda con restitución de excedentes bajo la Ley N° 21.674.';
        this.viewModalNotifcation = false;
      break;
      case 'no-validar-datos':
        this.themeBannerCompensacion = 'bannerCompensacion no-validar-datos';
        this.tituloModal = '¡Lo sentimos!';
        this.parrafoModal = 'No hemos podido verificar tu identidad con los datos recibidos. Por favor revísalos e intenta nuevamente.';
        this.viewModalNotifcation = false;
      break;
      case 'error':
        this.themeBannerCompensacion = 'bannerCompensacion error';
        this.tituloModal = '¡Ups!';
        this.parrafoModal = 'Ha ocurrido un error inesperado. Por favor, intente nuevamente más tarde.';
        this.viewModalNotifcation = false;
      break;
      case 'revisar-datos':
        this.themeBannerCompensacion = 'bannerCompensacion revisar-datos';
        this.tituloModal = '¡Perfecto!';
        this.parrafoModal = 'Puedes revisar los datos de tú solicitud';
        this.viewModalNotifcation = false;
      break;
      case 'firmar-mandato':
        this.themeBannerCompensacion = 'bannerCompensacion firmar-mandato';
        this.tituloModal = '¡Tu beneficio está a un paso!';
        this.viewModalNotifcation = true;
      break;
    }

    this.viewModal = true;

  }

  cerrarModal($event:any){
    // console.log('cerrarModal', $event);
    this.viewModal = false;
    // this.refreshPage();
  }

  executeRecaptchav2() {
    // this.disabledBtn = true;
    document.getElementById("recaptcha2")!.style.display = "block";
    grecaptcha.ready(() => {
      grecaptcha.render('recaptcha2', {
        'sitekey': environment.recaptcha.siteKeyV2,
        //'size': 'invisible',
        'callback': this.verifyRecaptcha
      });
      // console.log('executeRecaptchav2');
    });
  }

  getResponseForm() {
    this.validacionIdentidad();
    gsap.to(window, { duration: 1, scrollTo: 0, delay: 2 });
  }

  verifyRut() {
    const { formattedRut, isValid } = this.utilsService.verifyRut(this.formData?.controls['username']?.value);
    // console.log('formattedRut', formattedRut);
    this.formData?.controls['username']?.setValue(formattedRut);
    this.verifyRutCampo = !isValid;
  }

  verifyNDocumento(){
    this.verifyDctoCampo = this.formData?.controls['nDocumento']?.value.length < 7;
  }

  goToLink(){
    window.open('https://www.colmena.cl/', '_blank');
  }

  cancelar(){
    this.refreshPage();
  }

  firmar(){
    console.log(this.formDataFirma.controls)
    // this.currentRutUser = '16629309-K'; // Usuario ya frimado
    // this.currentRutUser = '12512297-3'; // Usuario sin firmar 
    // console.log('this.currentRutUser', this.currentRutUser);
    this.restitucionService.suscripcionMandatoRestitucion().subscribe( (respMandato:any) => {
      // console.log('respMandato', respMandato);
      // respMandato.resultadoEjecucion.codigoRetorno = 0;
      if (respMandato.resultadoEjecucion.codigoRetorno === 0) { // usuario primera firma ok
        this.folioMandato = respMandato['folio'];
        this.nombreAfiliado = respMandato['nombreAfiliado'];
        this.codeResponseNotification = 0;
        this.viewNotificationFirma = true;
        console.log("nombre afiliado: "+this.nombreAfiliado);
      }
      if (respMandato.resultadoEjecucion.codigoRetorno === 1) { //  error al insertar 
        this.codeResponseNotification = 1;
        this.viewNotificationFirma = true;
      }
      if (respMandato.resultadoEjecucion.codigoRetorno === 2) { // ya existe mandato
        this.folioMandato = respMandato['folio'];
        this.codeResponseNotification = 2;
        this.viewNotificationFirma = true;
      }
      if (respMandato.resultadoEjecucion.codigoRetorno === 3) { // no corresponde que firme mandato
        this.codeResponseNotification = 1;
        this.viewNotificationFirma = false;
      }
    });

    // console.log('params para notificacion', {
    //   'typeApp': this.typeApp,
    //   'this.codeResponseNotification': this.codeResponseNotification,
    //   'this.currentRutUser': this.currentRutUser
    // });

    // this.viewNotificationFirma = true;

    // LLAMAREMOS AL SERVICIO PARA REALIZAR FIRMA MANDATO Y CON ESE CODIGO REALIZAREMOS EL PASO 
    // A LA PANTALLA DE NOTIFICACION DE FIRMA MANDATO
    // CODE 0 ES // SUCCSES
    // CODE 1 ES // ERROR 

    // this.router.navigate( ['/notificacion-firma-mandato'],{queryParams:{result : codeResponse, code: this.typeApp}} );
  }

  verPreMandato(){
    // alert('abrir pre mandato');
    this.styleBtnPreMandato = 'btn-volver';
    this.labelBtnPreMandato = 'Pre Mandato';
    this.revisorPreMandato = true;
  }

  ingresarUsuarioBifurcacion(context:any) {
    if(context === 'afiliado') {
      window.open('https://www.colmena.cl/afiliados/#/login', '_blank');
    }

    if(context === 'no-afiliado') {
      this.tabView_index = 0;
    }

  }

}
